import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var loglevel = {exports: {}};

/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/

(function (module) {
	(function (root, definition) {
	    if (module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(commonjsGlobal, function () {

	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
	        /Trident\/|MSIE /.test(window.navigator.userAgent)
	    );

	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];

	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }

	    // Trace() doesn't print the message in IE, so for that case we need to wrap it
	    function traceForIE() {
	        if (console.log) {
	            if (console.log.apply) {
	                console.log.apply(console, arguments);
	            } else {
	                // In old IE, native console methods themselves don't have apply().
	                Function.prototype.apply.apply(console.log, [console, arguments]);
	            }
	        }
	        if (console.trace) console.trace();
	    }

	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }

	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (methodName === 'trace' && isIE) {
	            return traceForIE;
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }

	    // These private functions always need `this` to be set properly

	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }

	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }

	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }

	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }

	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;

	      var storageKey = "loglevel";
	      if (typeof name === "string") {
	        storageKey += ":" + name;
	      } else if (typeof name === "symbol") {
	        storageKey = undefined;
	      }

	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

	          if (typeof window === undefinedType || !storageKey) return;

	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}

	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }

	      function getPersistedLevel() {
	          var storedLevel;

	          if (typeof window === undefinedType || !storageKey) return;

	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}

	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }

	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }

	          return storedLevel;
	      }

	      function clearPersistedLevel() {
	          if (typeof window === undefinedType || !storageKey) return;

	          // Use localStorage if available
	          try {
	              window.localStorage.removeItem(storageKey);
	              return;
	          } catch (ignore) {}

	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	          } catch (ignore) {}
	      }

	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */

	      self.name = name;

	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};

	      self.methodFactory = factory || defaultMethodFactory;

	      self.getLevel = function () {
	          return currentLevel;
	      };

	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };

	      self.setDefaultLevel = function (level) {
	          defaultLevel = level;
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };

	      self.resetLevel = function () {
	          self.setLevel(defaultLevel, false);
	          clearPersistedLevel();
	      };

	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };

	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };

	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }

	    /*
	     *
	     * Top-level API
	     *
	     */

	    var defaultLogger = new Logger();

	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }

	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };

	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }

	        return defaultLogger;
	    };

	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };

	    // ES6 default export, for compatibility
	    defaultLogger['default'] = defaultLogger;

	    return defaultLogger;
	})); 
} (loglevel));

var loglevelExports = loglevel.exports;
var logFactory = /*@__PURE__*/getDefaultExportFromCjs(loglevelExports);

var LOGGER_NAME = 'om-translations-logger';
var DEFAULT_LOGGING_LEVEL = 'SILENT';
// Global Logger Instance
var logger = null;
var validateLoggingLevel = function (inboundLoggingLevel) {
    if (inboundLoggingLevel === undefined ||
        inboundLoggingLevel === null ||
        inboundLoggingLevel === '')
        return false;
    var isValid = false;
    // support inbound level as a number in [0, 5]
    if (typeof inboundLoggingLevel === 'number') {
        if (inboundLoggingLevel >= 0 && inboundLoggingLevel <= 5)
            isValid = true;
    }
    else if (typeof inboundLoggingLevel === 'string') {
        var caseCorrectedInput_1 = inboundLoggingLevel.toUpperCase();
        Object.keys(logFactory.levels).forEach(function (lvl) {
            if (caseCorrectedInput_1 === lvl) {
                isValid = true;
            }
        });
    }
    return isValid;
};
/**
 * Initialized a library logger at the specified level. If the logger is already instantiated, it will return the logger.
 *
 * @param {*} level - The level to build the logger with. This disables all logging below the given level,
 * so that after a log.setLevel("warn") call log.warn("something") or log.error("something") will output messages,
 * but log.info("something") will not.
 *
 * Returns the initialized logger, or the existing logger if already initialized.
 */
var initializeLogger = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.level, level = _c === void 0 ? '' : _c;
    if (logger) {
        logger.warn('Logger Already Initialized!');
        return logger;
    }
    var inboundLoglevelIsValid = validateLoggingLevel(level);
    if (!inboundLoglevelIsValid) {
        // core library logging for invalid arguments
        // eslint-disable-next-line no-console
        console.error('Invalid logging level provided, returning a silent logger. There will be no console output.');
    }
    var logginglevel = inboundLoglevelIsValid
        ? level
        : logFactory.levels.SILENT;
    var loggerUtility = logFactory.getLogger(LOGGER_NAME);
    loggerUtility.setLevel(logginglevel, false);
    logger = loggerUtility;
    logger.trace('Initialized Logger with level:', level);
    return logger;
};
var getLogger = function () {
    if (!logger) {
        initializeLogger({ level: DEFAULT_LOGGING_LEVEL });
    }
    return logger;
};

/**
 * Definitions
 *
 * OM Translation Schema: A JSON Schema that requires a translation file:
 * - Is named after the locale of which the translations correspond to.
 * - Has a top level JSON object whose keys correspond to Translation Groups (ex A).
 * - Whose sub-properties within a given Translation Group are either (ex B)
 * Translation Target(key) and Translation Value Strings(value), or (ex C)a Translation
 * Target(key) and Translation Value Objects(value).
 *
 * file: [en-US.json]
 * {
 * "welcomeBanner":                                                               (ex A)
 *    "headlinePhrase": "Hello World!",                                           (ex B)
 *    "headlineLegalText": {                                                      (ex C)
 *      "value": "California Prop 65 Anti Fun Warning!",
 *      "_context": "Required by legal, required additional QA from Jane Doe."
 *    }
 * }
 *
 * Translation Dictionary: An object that stores all translations for a given
 * locale in accordance to the OM Translation Schema.
 *
 * Translation Group: A named grouping of an arbitrary set of Translation
 * Target & Values. Typically (but not always), a Group provides translations to a single
 * UI Component. Required to be a top level sub-property of a transation dictionary.
 *
 * Translation Target: A unique identifier within a Translation Group used at runtime to
 * retrieve which translation value should be injected into the application.
 * It is the key value of a sub-property in a Translation Group.
 *
 * Translation Value String(simple): The value associated to a translation target. This is typically the
 * string of text that will appear to the user (unless it contains tokens for further extrapolation)
 *
 * Translation Value Object(complex): The object value associated to a translation target. This is an object
 * that requires a sub-property of 'value', which encapsulates the string of text that will typically
 * appear to the user (unless it contains tokens for further extrapolation). Additional sub-properties
 * of this object are typically used for metadata.
 *
 * Target Locale: The developer specified locale that the application wants translation strings in.
 *
 * Active Translation Dictionary: The Target Locale's Translation Dictionary initialized for this application.
 *
 * Default Translation Dictionary: Primarily used for informative error/warning logging when translation translationg groups or string
 * targets(referenced at runtime from the activeTranslationDictionary) do not exist.
 *
 * logLevel: The console logging level to run the om-translation library with. If none provided, logger will default to SILENT.
 *    Will DEFAULT to SILENT if no level is provided OR if the provided level is unsupported.
 *    Supported Log Levels (case insensitive or number accepted):
 *    "TRACE"|0 : Execution processing log messages for high visibile traceability
 *    "DEBUG"|1 : Detailed processing log messages to help describe runtime executions.
 *    "INFO"|2 : Informational messages that highlight the progress of processing translation requests
 *    "WARN"|3 : Potentially harmful situations of interest
 *    "ERROR"|4 : Important issues that will prevent the library from running properly
 *    "SILENT"|5 : No console output during course of execution
 */
// The default locale serving as a key into the TRANSLATION_DICTIONARIES for a default translation set.
var DEFAULT_TRANSLATION_LOCALE = 'en-us';
var LocalizationContext = createContext({
    activeTranslationDictionary: {},
    defaultTranslationDictionary: {},
    targetLocale: '',
    setLocale: function () { },
});
var LocalizationProvider = function (_a) {
    var children = _a.children, translationResources = _a.translationResources, _b = _a.locale, locale = _b === void 0 ? '' : _b, _c = _a.logLevel, logLevel = _c === void 0 ? DEFAULT_LOGGING_LEVEL : _c;
    var LOGGER = React.useMemo(function () { return initializeLogger({ level: logLevel }); }, [logLevel]);
    var _d = useState(locale), localeState = _d[0], setLocaleState = _d[1];
    React.useEffect(function () {
        if (locale) {
            setLocaleState(locale.toLowerCase());
        }
    }, [locale]);
    // An object encapsulating the entire set of all locales(key)_= with their associative
    // translation dictionary(value). Used to retrieve the
    // applications 'active' translation dictionary and default translation dictionary.
    var TRANSLATION_DICTIONARIES = translationResources;
    var localizationContextValues = useMemo(function () {
        var activeTranslationDictionary = TRANSLATION_DICTIONARIES[localeState.toLowerCase()] || {};
        var defaultTranslationDictionary = TRANSLATION_DICTIONARIES[DEFAULT_TRANSLATION_LOCALE] || {};
        return {
            activeTranslationDictionary: activeTranslationDictionary,
            defaultTranslationDictionary: defaultTranslationDictionary,
            targetLocale: localeState,
            setLocale: setLocaleState,
        };
    }, [TRANSLATION_DICTIONARIES, localeState]);
    LOGGER.trace("[LocalizationProvider] Rendering with locale: ".concat(localeState), translationResources, localizationContextValues.activeTranslationDictionary, localizationContextValues.defaultTranslationDictionary);
    return (React.createElement(LocalizationContext.Provider, { value: localizationContextValues }, children));
};

/**
 * Provide callbacks for checking if copys are in certain translation groups.
 * @example const {localizationLookUpFunction} = useCopyValidation();
 *
 * @returns A callback for validating single translation group.
 */
var useCopyValidation = function () {
    var activeTranslationDictionary = useContext(LocalizationContext).activeTranslationDictionary;
    /**
     * Callback for validating single translation group.
     * @param groupName String translation group name
     * @param keyArray Array of expected keys in the translation group
     * @example groupName: 'groupA'; keyArray: ['key1', 'key2']
     * @returns An object containing all of all missing keys in given translation group
     */
    var localizationLookUpFunction = useCallback(function (groupName, keyArray) {
        var isGroupNameValid = !!activeTranslationDictionary[groupName];
        if (!isGroupNameValid) {
            return {
                hasAllCopy: false,
                copiesMissing: ["Translation group not found"],
            };
        }
        var copiesMissing = keyArray.filter(function (x) {
            return !Object.keys(activeTranslationDictionary[groupName]).includes(x);
        });
        return { hasAllCopy: copiesMissing.length === 0, copiesMissing: copiesMissing };
    }, [activeTranslationDictionary]);
    return { localizationLookUpFunction: localizationLookUpFunction };
};

/**
 * @param {*} translationGroup the name of the Translation Group to provide look-up access into.
 * @param {*} targetLocale the Active Translation Dictionary's target locale.
 * @param {*} activeTranslationGroup the translationGroup's dictionary of
 * translation target(key): translation value(value) pairs
 * @param {*} defaultTranslationGroup the translationGroup of the Default Translation Dictionary
 *
 * @returns A Javascript Proxy for resilient Translation Target look-up in a given Translation Group.
 */
var proxiedTranslations = function (_a) {
    var translationGroup = _a.translationGroup, targetLocale = _a.targetLocale, _b = _a.activeTranslationGroup, activeTranslationGroup = _b === void 0 ? {} : _b, _c = _a.defaultTranslationGroup, defaultTranslationGroup = _c === void 0 ? {} : _c, logger = _a.logger;
    // return a proxy object with a handler override on the 'get' function.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/get
    return new Proxy({}, {
        get: function (_, translationTarget) {
            // activeTranslationGroup contains the target group
            if (Object.prototype.hasOwnProperty.call(activeTranslationGroup, translationTarget)) {
                var translation = activeTranslationGroup[translationTarget];
                // simple translation value of a string, return it
                if (typeof translation === 'string')
                    return translation;
                // complex translation value object, return the subproperty 'value' or the fallback object if 'value' DNE.
                if (typeof translation === 'object' &&
                    translation.value &&
                    typeof translation.value === 'string')
                    return translation.value;
                logger.error("".concat(translationTarget, " is invalid in translation group: ").concat(translationGroup));
                return "[".concat(translationGroup, ".").concat(translationTarget, "]");
            }
            // activeTranslationGroup does not contain the target group, try the default translation dictionary to
            // better warn the end user.
            if (defaultTranslationGroup[translationTarget]) {
                logger.warn("".concat(translationTarget, " does not exist in translation group: ").concat(translationGroup, " in targetLocale: ").concat(targetLocale, ", however does exist in DEFAULT language."));
            }
            else {
                logger.error("".concat(translationTarget, " does not exist in translation group: ").concat(translationGroup, " in targetLocale: ").concat(targetLocale, ", or in DEFAULT language."));
            }
            // return fallback string
            return "[".concat(translationGroup, ".").concat(translationTarget, "]");
        },
    });
};
var proxiedTranslationsForMissingTargetGroup = function (_a) {
    var missingTranslationGroup = _a.missingTranslationGroup, defaultTranslationDictionary = _a.defaultTranslationDictionary, targetLocale = _a.targetLocale, logger = _a.logger;
    if (defaultTranslationDictionary[missingTranslationGroup]) {
        logger.warn("No Translation Group: ".concat(missingTranslationGroup, " in ").concat(targetLocale, ", this group DOES exist in default language!"));
    }
    else {
        logger.error("No Translation Group: ".concat(missingTranslationGroup, " in ").concat(targetLocale, " or DEFAULT language."));
    }
    return proxiedTranslations({
        translationGroup: missingTranslationGroup,
        targetLocale: targetLocale,
        defaultTranslationGroup: defaultTranslationDictionary[missingTranslationGroup],
        logger: logger,
    });
};
/**
 * @param {*} translationGroups An array of strings where each string corresponds to a given
 * Translation Group within an Translation Dictionary.
 *
 * @example Without copy validation
 * const [transGroupOne, transGroupTwo ] = useTranslations(['transGroupOne', 'transGroupTwo'])
 * @example With copy validation
 * const [transGroupOne, transGroupTwo, localizationLookUpFunction] = useTranslations(['transGroupOne', 'transGroupTwo'])
 *
 * @returns An array of Javacsript Proxy objects that correspond to each inbound translation group,
 * order is preserved from the inbound array.
 * The Proxy Object has a 'get' handler override intended to be a look-up tool for translation targets
 * in a given translation group. The proxy provides additional logging (console errors and warnings) when
 * attempting to access translation groups and targets.
 *
 * Attempting to access a translation group that is not present in the active or default translation dictionary will
 * yield console errors and a proxy that console error on every translation target look-up.
 *
 * Attempting to access a translation group that is not present in the active translation dictionary but is present
 * in the default translation dictionary will yield a console warning and a proxy that will either
 * yield console errors or warnings for translation target look-ups depending on whether or not the default translation
 * group contains the target.
 *
 * The proxy object will return a 'fallback string' whenever it cannot resolve a translation target. The 'fallback string'
 * will be in the format of: ${Translation Group}.{Translation Target}
 *
 * Named destructuring is recommended when using this hook!
 * Example:
 * const [transGroupOne, transGroupTwo] = useTranslations(['transGroupOne', 'transGroupTwo'])
 *
 * Javascript Proxy: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy
 */
var useTranslations = function (translationGroups) {
    var _a = useContext(LocalizationContext), activeTranslationDictionary = _a.activeTranslationDictionary, defaultTranslationDictionary = _a.defaultTranslationDictionary, targetLocale = _a.targetLocale;
    var LOGGER = getLogger();
    var localizationLookUpFunction = useCopyValidation().localizationLookUpFunction;
    return translationGroups
        .map(function (groupName) {
        return activeTranslationDictionary[groupName]
            ? proxiedTranslations({
                translationGroup: groupName,
                activeTranslationGroup: activeTranslationDictionary[groupName],
                defaultTranslationGroup: defaultTranslationDictionary[groupName],
                targetLocale: targetLocale,
                logger: LOGGER,
            })
            : proxiedTranslationsForMissingTargetGroup({
                missingTranslationGroup: groupName,
                defaultTranslationDictionary: defaultTranslationDictionary,
                targetLocale: targetLocale,
                logger: LOGGER,
            });
    })
        .concat([localizationLookUpFunction]);
};

/**
 * @param {*} tokenizedString The input string to classify into tokens.
 * @returns An array of token objects in the order that they were parsed, from left to right across the string.
 *
 * Token Objects can be of three different shapes:
 * (1) { text:'Hello ' }
 * (2) { token: '{{{couponName}}}' }
 * (3) { nestedTokenName: 'moreInfoLink', nestedText: 'More info avalable here.'}
 *
 * A more readable version of the sticky regular expression is the following, where each match to a corresponding token object is on its own line...
 * /
 *  (\{\{\{start([^}]+)\}\}\}(.+)\{\{\{end\2\}\}\})|
 *  \{\{\{([^}]+)\}\}\}|
 *  ([^{]+)
 * /y;
 *
 */
var parseTokenizedString = function (tokenizedString) {
    var tokenRegext = /(\{\{\{start([^}]+)\}\}\}(.+)\{\{\{end\2\}\}\})|\{\{\{([^}]+)\}\}\}|([^{]+)/y;
    var lastMatch;
    var fetchNext = function (str) { return (lastMatch = tokenRegext.exec(str)); };
    var tokens = [];
    while (fetchNext(tokenizedString)) {
        var _a = lastMatch || []; 
        /* _ has to be here, otherwise parseTokenizedString fails, but it isn't used? */
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
        _a[0]; var wholeNestedToken = _a[1], nestedTokenName = _a[2], nestedText = _a[3], token = _a[4], text = _a[5];
        if (wholeNestedToken) {
            tokens.push({ nestedTokenName: nestedTokenName, nestedText: nestedText });
        }
        else if (token) {
            tokens.push({ token: token });
        }
        else if (text) {
            tokens.push({ text: text });
        }
    }
    return tokens;
};
/**
 * ReplaceTokens is a component that can extrapolate TokenizedStrings into a JSX component tree with their translated values.
 * It also exposes a mutant Render Props-ish ability to handle nested tokenization.
 *
 * Why is it a mutant Render Props component? If you want to take advantage of our recursive complex tokenization
 * replacement. We achieve this by identifying the start and end of a nested component, and wrapping its nested text
 * by calling a substitution function with the nestedText as the children.
 *
 * Failing to pass a substitution function that takes a children parameter and returns JSX wrapping that children object
 * will return ONLY the nested text, and no further tokenization of that nested value.
 *
 * Fruther more, failing to provide a substitution for a token will result in that token not being included in the output.
 *
 * 'Simple' replacements are tokens that occur once and are to be exchanged with the value from the
 * substitution dictionary provided to the component.
 * Ex: {{{shopperName}}}
 *
 * 'Nested' replacements are complex tokens that identify as a touple pair in the string. The naming
 * convention for nested tokens requires that the first token begins with 'start' in its name, and the
 * closing token begins with 'end' in its name.
 * Ex: {{{startInfoLink}}} More Info! {{{endInfoLink}}}
 *
 * In the following example, we want to take a tokenized string and do two 'simple' replacements, injecting
 * in the shopperIdentifier and the currently applied coupon code. Additionally, we want to styalize nested
 * text for a link we provide to the customer via a 'nested' replacement.
 *
 Example Usage:

  const activeCoupon = 'VPover9000';
  const shopperFirstName = 'Andrew';
  const myLink = ({ children }) => <Link>{children}</Link>;

  myLink.propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

 <ReplaceTokens
    tokenizedString="Coupon {{{coupon}}} has been applied. {{{beginmoreInfoLink}}}More info avalable here, {{{shopperIdentifier}}}. {{{endmoreInfoLink}}}"
      subs={{
        coupon: <PromoCode>{activeCoupon}</PromoCode>,
        shopperIdentifier: <i>{shopperFirstName}</i>,
        moreInfoLink: myLink,
      }}
  />
 *
 * @param {*} tokenizedString the inbound string to be Tokenized and formatted into a proper React Component hierarchy.
 * @param {*} substitutions A dictionary containing token names (keys), and their replacements.
 * Replacements can either be, strings(simple replace), React/valid HTML Components(simple replace with html elements),
 * or a function (nested complex replacement). If providing a nested function replacement, the function you assign to
 * the nested token MUST take children as a parameter, AND wrap children in a render-props-esque fashion in order for
 * proper replacement. See example above.
 */
var ReplaceTokens = function (_a) {
    var tokenizedString = _a.tokenizedString, substitutions = _a.substitutions;
    var LOGGER = getLogger();
    var tokens = parseTokenizedString(tokenizedString);
    LOGGER.info("[ReplaceTokens] tokeniedString: ".concat(tokenizedString, " Tokens: ").concat(tokens.toString()));
    return (React.createElement(React.Fragment, null, tokens.map(function (parsedToken, index) {
        var token = parsedToken.token, text = parsedToken.text, nestedText = parsedToken.nestedText, nestedTokenName = parsedToken.nestedTokenName;
        if (text) {
            return React.createElement("span", { key: index }, text);
        }
        if (token) {
            if (!substitutions[token]) {
                LOGGER.error("No substitution provided for token ".concat(token, ", returning empty element."));
                return null;
            }
            return React.createElement("span", { key: index }, substitutions[token]);
        }
        if (nestedTokenName) {
            var children = (React.createElement(ReplaceTokens, { substitutions: substitutions, tokenizedString: nestedText }));
            if (!substitutions[nestedTokenName]) {
                LOGGER.error("No substitute component provided for nested token ".concat(nestedTokenName, ", returning children without wrapping."));
                return children;
            }
            if (typeof substitutions[nestedTokenName] !== 'function') {
                LOGGER.error("Substitue provided for nested token ".concat(nestedTokenName, ", was not a function, returning children without wrapping."));
                return children;
            }
            return substitutions[nestedTokenName]({
                children: children,
            });
        }
        return null;
    })));
};

export { LocalizationContext, LocalizationProvider, ReplaceTokens, useCopyValidation, useTranslations };
//# sourceMappingURL=index.esm.js.map
